import axios from './axios';

const getSingleton = singleton => axios.get(`singletons/get/${singleton}`);
const getCollection = collection => axios.get(`collections/get/${collection}`);

export default {
  getSingleton: getSingleton,
  getCollection: getCollection
}